import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_58.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter58.json";
import Head from "next/head";
export default function Chapter_58() {

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>
      <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Liberation through presence, Perennial Mandalism, spiritual discipline, compassion, integrity, truth beyond dogma, awakening now."
        ></meta>
        <meta
          property="og:title"
          content="The Hard Path to Liberation: Truth in the Present Moment"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="True liberation is not a promised afterlife but a state of being realized now. Perennial Mandalism rejects spiritual elitism, embracing disciplined action, integrity, and presence over absolutist dogma. While honoring traditions like Christianity and Hare Krishna, it calls seekers to awaken here and now, tending life’s garden with patience, compassion, and direct experience as the path to truth."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=58"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=58"
        ></meta>
        <meta
          name="twitter:title"
          content="The Hard Path to Liberation: Truth in the Present Moment"
        ></meta>
        <meta
          name="twitter:description"
          content="Liberation is not found in distant heavens but within the present moment. Perennial Mandalism honors diverse traditions while rejecting exclusivity, urging seekers to live with integrity, discipline, and compassion. By embracing direct experience over rigid dogma, we awaken to our divine nature now, cultivating the garden of life as our true spiritual work."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=58" />
      </Head>
      <Common_html BlockData={BlockData} />
    </>
  );
}
